// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__wR8S2","title":"ClientInsurance_title__9Xj_A","itemText":"ClientInsurance_itemText__6GdpF"};